<template>
  <div class="authSupportModalContent">
    <div class="authSupportModalContent_wrapper">
      <div class="authSupportModalContent_preHeader">
        <div class="authSupportModalContent_close" @click="closeModal"></div>
      </div>
      <div class="authSupportModalContent_header">
        <div class="authSupportModalContent_logo">
          <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="72" height="72" rx="22" fill="#E7DCFF"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M47.4283 33.452C46.9854 29 44.2997 22 35.9999 22C27.7 22 25.0143 29 24.5714 33.452C23.0179 34.0298 21.9931 35.4916 22 37.12V39.08C22 41.245 23.7909 43 26 43C28.2091 43 30 41.2449 30 39.08V37.12C29.9927 35.5267 29.0057 34.095 27.4999 33.494C27.7857 30.918 29.1857 24.8 35.9999 24.8C42.8141 24.8 44.1998 30.918 44.4855 33.494C42.9828 34.0963 42.0007 35.529 41.9998 37.12V39.08C42.0029 39.8176 42.2175 40.5395 42.6191 41.1633C43.0207 41.7871 43.5932 42.2877 44.2712 42.608C43.6712 43.714 42.1426 45.212 38.3855 45.66C37.6345 44.5424 36.1815 44.1018 34.9176 44.6084C33.6538 45.1151 32.9324 46.4274 33.196 47.7404C33.4596 49.0534 34.6344 50 35.9999 50C36.529 49.9971 37.0469 49.8503 37.4958 49.5759C37.9448 49.3015 38.3072 48.9104 38.5427 48.446C44.6712 47.76 46.6283 44.666 47.2426 42.846C48.9044 42.3184 50.0221 40.7918 49.9997 39.08V37.12C50.0066 35.4916 48.9818 34.0298 47.4283 33.452ZM27.1428 39.08C27.1428 39.6985 26.6312 40.2 26 40.2C25.3688 40.2 24.8572 39.6986 24.8572 39.08V37.12C24.856 36.9722 24.8847 36.8256 24.9416 36.6887C24.9985 36.5519 25.0825 36.4274 25.1888 36.3225C25.295 36.2176 25.4214 36.1343 25.5606 36.0775C25.6998 36.0206 25.8492 35.9914 26 35.9914C26.1508 35.9914 26.3001 36.0206 26.4394 36.0775C26.5786 36.1343 26.705 36.2176 26.8112 36.3225C26.9174 36.4274 27.0014 36.5519 27.0584 36.6887C27.1153 36.8256 27.144 36.9722 27.1428 37.12V39.08ZM44.8569 37.12C44.8569 36.5014 45.3685 36 45.9997 36C46.6309 36 47.1426 36.5014 47.1426 37.12V39.08C47.1426 39.6985 46.6309 40.2 45.9997 40.2C45.3685 40.2 44.8569 39.6986 44.8569 39.08V37.12Z" fill="#8C6BF9"/>
          </svg>
        </div>
        <div class="authSupportModalContent_title">{{ $t('auth.supportModal.title') }}</div>
        <div class="authSupportModalContent_description">{{ $t('auth.supportModal.description') }}</div>
      </div>

      <div class="authSupportModalContent_body">
        <div v-if="telegramUrl" @click="openTelegram" class="authSupportModalContent_servicesVariant -telegram">
          <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_18923_5901)">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M2.94364 8.74888C8.58077 6.20867 12.3397 4.534 14.2206 3.72489C19.5907 1.4147 20.7065 1.01339 21.4338 1.00014C21.5938 0.997227 21.9514 1.03823 22.1831 1.23267C22.3787 1.39685 22.4326 1.61863 22.4583 1.77429C22.4841 1.92995 22.5162 2.28455 22.4907 2.56163C22.1997 5.7241 20.9405 13.3986 20.2999 16.9406C20.0288 18.4394 19.4951 18.9419 18.9784 18.9911C17.8554 19.098 17.0027 18.2235 15.9151 17.4861C14.2132 16.3323 13.2517 15.614 11.5997 14.488C9.69056 13.1868 10.9282 12.4716 12.0162 11.3027C12.301 10.9969 17.2486 6.34226 17.3444 5.92001C17.3564 5.86721 17.3675 5.67036 17.2544 5.56642C17.1414 5.46248 16.9745 5.49802 16.8541 5.52629C16.6834 5.56636 13.9646 7.42501 8.69761 11.1022C7.92588 11.6503 7.22687 11.9174 6.60058 11.9034C5.91015 11.888 4.58204 11.4996 3.59473 11.1677C2.38374 10.7606 1.42128 10.5453 1.50509 9.85385C1.54874 9.4937 2.02826 9.12538 2.94364 8.74888Z" fill="white"/>
            </g>
            <defs>
              <clipPath id="clip0_18923_5901">
                <rect width="22" height="22" fill="white" transform="translate(0.5)"/>
              </clipPath>
            </defs>
          </svg>
          <span>{{ $t('connectIn', { service: 'Telegram' }) }}</span>
          <span/>
        </div>
        <div v-if="whatsappUrl" @click="openWhatsapp" class="authSupportModalContent_servicesVariant -whatsapp">
          <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_18923_5906)">
              <path d="M1 22L2.5538 16.3506C1.59499 14.6969 1.09118 12.8223 1.0921 10.9001C1.09487 4.89042 6.00862 0 12.0461 0C14.9759 0.000916667 17.7261 1.13667 19.7948 3.19733C21.8625 5.258 23.0009 7.997 23 10.9102C22.9972 16.9208 18.0835 21.8112 12.0461 21.8112C10.2132 21.8103 8.40702 21.3528 6.80717 20.4838L1 22ZM7.07611 18.5103C8.61978 19.4223 10.0934 19.9687 12.0424 19.9696C17.0602 19.9696 21.1478 15.9051 21.1505 10.9083C21.1524 5.9015 17.0841 1.8425 12.0497 1.84067C7.02822 1.84067 2.9434 5.90517 2.94156 10.901C2.94063 12.9406 3.54115 14.4677 4.54969 16.0655L3.62957 19.4095L7.07611 18.5103ZM17.564 13.5016C17.4959 13.3879 17.3135 13.3201 17.039 13.1835C16.7655 13.0469 15.4198 12.3878 15.1684 12.2971C14.9179 12.2063 14.7355 12.1605 14.5522 12.4337C14.3698 12.7059 13.8448 13.3201 13.6855 13.5016C13.5262 13.6831 13.3659 13.706 13.0924 13.5694C12.8188 13.4328 11.9364 13.1459 10.8911 12.2173C10.0778 11.495 9.52792 10.6031 9.36858 10.3299C9.20924 10.0577 9.352 9.91008 9.48832 9.77442C9.61174 9.6525 9.76187 9.45633 9.8991 9.29683C10.0382 9.13917 10.0833 9.0255 10.1754 8.84308C10.2666 8.66158 10.2215 8.50208 10.1524 8.3655C10.0833 8.22983 9.53621 6.88875 9.30872 6.34333C9.08582 5.81258 8.86017 5.88408 8.69254 5.87583L8.16755 5.86667C7.98518 5.86667 7.6886 5.9345 7.43808 6.20767C7.18756 6.48083 6.4802 7.139 6.4802 8.48008C6.4802 9.82117 7.46111 11.1164 7.59742 11.2979C7.73466 11.4794 9.527 14.2313 12.2726 15.411C12.9256 15.6915 13.4359 15.8593 13.8329 15.9848C14.4887 16.192 15.0855 16.1627 15.5571 16.093C16.083 16.0151 17.1763 15.4339 17.4047 14.7978C17.6331 14.1607 17.6331 13.6153 17.564 13.5016Z" fill="white"/>
            </g>
            <defs>
              <clipPath id="clip0_18923_5906">
                <rect width="22" height="22" fill="white" transform="translate(0.5)"/>
              </clipPath>
            </defs>
          </svg>
          <span>
            {{ $t('connectIn', { service: 'WhatsApp' }) }}
          </span>
          <span/>
        </div>
        <div v-if="maxUrl" @click="openMax" class="authSupportModalContent_servicesVariant -max">
          <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.7256 19.9429C9.66473 19.9429 8.707 19.6552 7.04225 18.504C5.98924 19.799 2.65472 20.8111 2.50931 19.0796C2.50931 17.7798 2.20845 16.6815 1.86748 15.4824C1.46132 14.0051 1 12.36 1 9.97626C1 4.28308 5.88394 0 11.6705 0C17.462 0 21.9999 4.49411 21.9999 10.029C22.0093 12.6461 20.9327 15.1599 19.0064 17.0186C17.0802 18.8772 14.4617 19.929 11.7256 19.9429ZM11.8109 4.92098C8.99281 4.78189 6.79655 6.64764 6.31016 9.57337C5.90901 11.9955 6.62104 14.9452 7.22778 15.0987C7.51861 15.1658 8.2507 14.5999 8.707 14.1634C9.46152 14.662 10.3401 14.9614 11.2543 15.0315C12.6579 15.0961 14.032 14.6314 15.0812 13.7372C16.1305 12.843 16.771 11.5908 16.8653 10.2496C16.9201 8.90574 16.4213 7.59493 15.476 6.59928C14.5307 5.60362 13.2146 5.00268 11.8109 4.92578V4.92098Z" fill="white" style="fill:white;fill-opacity:1;"/>
          </svg>
          <span>
            {{ $t('connectIn', { service: 'Max' }) }}
          </span>
          <span/>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useSupportContacts } from '@web/composition/useSupportContacts'

defineOptions({
  name: 'AuthSupportModalContent'
})

const emit = defineEmits(['close'])

const {
  telegramUrl,
  whatsappUrl,
  maxUrl,
  openTelegram,
  openWhatsapp,
  openMax
} = useSupportContacts()

const closeModal = () => {
  emit('close')
}
</script>

<style lang="scss" scoped>
@import '~@web/assets/scss/textContents.scss';

.authSupportModalContent {
  font-family: Inter;

  &_wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: var(--ac-color-white);
    border-radius: 18px;
    padding: 20px;
    width: 360px;

    @media (max-width: 768px) {
      padding-bottom: calc(constant(safe-area-inset-bottom, 0) + 20px);
      padding-bottom: calc(env(safe-area-inset-bottom, 0) + 20px);
      width: 100%;
      border-radius: 18px 18px 0 0;
    }
  }

  &_preHeader {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    margin-bottom: 6px;
  }

  &_close {
    width: 28px;
    height: 28px;
    background: url('~@ui-kit/icons/icon-close-28-black.svg') no-repeat center center;
    background-size: 100% 100%;
    cursor: pointer;
  }

  &_header {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-bottom: 28px;
  }

  &_logo {
    width: 72px;
    height: 72px;
    margin-bottom: 18px;
  }

  &_title {
    @extend .text-lg-medium;
    color: var(--ac-color-black);
    margin-bottom: 2px;
    text-align: center;
  }

  &_description {
    @extend .text-sm;
    color: var(--ac-color-dark-gray);
    text-align: center;
  }

  &_body {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    gap: 12px;
  }

  &_servicesVariant {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    width: 100%;
    padding: 14px;
    border-radius: 32px;
    height: 50px;
    cursor: pointer;
    text-decoration: none;
    color: var(--ac-color-white);
    font-weight: 400;
    font-size: 16px;
    line-height: 130%;

    &.-telegram {
      background-color: #28A8E8;
    }
    &.-whatsapp {
      background-color: #25D366;
    }
    &.-max {
      background: linear-gradient(73.55deg, #00CFFF 14.56%, #5B31F8 63.57%, #A628E5 88.6%), #00ABEE;
      background: linear-gradient(73.55deg, color(display-p3 0.267 0.800 1.000) 14.56%, color(display-p3 0.333 0.200 0.933) 63.57%, color(display-p3 0.600 0.200 0.867) 88.6%), color(display-p3 0.157 0.659 0.910);
    }

    svg {
      width: 22px;
      height: 22px;
      flex-shrink: 0;
    }

    span {
      white-space: nowrap;

      &:empty {
        width: 22px;
        flex-shrink: 0;
      }
    }
  }
}
</style>
